import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Icon, Button, Label, Modal, Divider, Feed } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';
import objectId from '../../../../helpers/objectId';

import Status from './ActiveInitiativeProgress/Status'
import Summary from './ConfigureActivities/Summary'
import Dependency from './ConfigureActivities/Dependency'
import AssignRole from './ConfigureActivities/Role';
import Reference from './ConfigureActivities/Reference'
import Notes from './ActiveInitiative/Notes'
import NotesModal from './../Drive/modals/Notes'
import InitiativeDetails from './ActiveInitiativeProgress/InitiativeDetails'
import IssueLogModal from '../Drive/modals/ViewIssueLog'
import FileUploader from '../../../drive/Attachments/UppyFileUpload';
import { singleLineText, urlValidation } from '../../../common/RegexValidation';
import { Form } from 'formsy-semantic-ui-react';
import ShowInitiativeMetaData from "../../../../components/workspace/lifecycleDesigner/drive/modals/ShowInitiativeMetaData";
import ImageAvater from '../../../../components/drive/Components/ImageAvater';
import momentDateAndTime from '../../../../helpers/momentDateAndTime';
import ProcessComponent from './ProcessComponent';
import DynamicForm from './DynamicForm';
var moment = require('moment');
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class ActiveInitiative extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            clickStatus: '',
            openIssueLog: false,
            activeIndex: 0,
            openDashboard: false,
            modalFlag: false
        }
    }

    handleUppyModalClick = () => {
        this.setState({
            openDashboard: !this.state.openDashboard
        });
    }


    close = () => {
        this.setState({ linkOpen: false, name: '', url: '' })
    }

    updateText = (data, name) => {
        if (name === "Add Link Name") {
            this.setState({ name: data })
        } else if (name === "Add Link") {
            this.setState({ url: data })
        }
    }

    addLink = () => {
        let attachments = this.props.selectedActivityData && this.props.selectedActivityData.attachments ? this.props.selectedActivityData.attachments : [];
        let document = {};
        document.documentName = this.state.name;
        document.documentId = objectId();
        document.documentUrl = this.state.url;
        document.uploadedBy = this.props.user && this.props.user._id;
        document.uploadedAt = moment();
        attachments.unshift(document);
        this.addAttachment(attachments)
        this.close()
    }

    addAttachment = (attachments) => {
        let attachmentPayload = {
            _id: this.props.selectedActivityData._id,
            attachments: attachments,
            initiativeId: this.props.selectedActivityData.initiativeId._id ? this.props.selectedActivityData.initiativeId._id : this.props.selectedActivityData.initiativeId
        }
        dispatch.initiatives.updateInitiativeActivities(attachmentPayload);
    }

    notesClick = (open, clickStatus) => {
        this.setState({ open: open, clickStatus: clickStatus })
    }
    viewIssueLogsClick = (openIssueLog) => {
        this.setState({ openIssueLog: openIssueLog })
    }
    // Below isWorkspaceOwner & isDesigner functions added for KLM-8942
    isWorkspaceOwner = () => {
        // const loggdinUserId = this.props.user._id;
        let authors =
            this.props.currentOrganization &&
            this.props.currentOrganization.users &&
            this.props.currentOrganization.users.filter(
                (el) =>
                    el.accountUserId === this.props.user._id &&
                    el.role === "workspaceOwner"
            );
        if (authors && authors.length > 0) {
            return true;
        }
        return null;
    };
    isDesigner = () => {
        if(this.props.initiativeOwnerDetails.email === this.props.user.email) {
            return true
        }
        return null
    }
    setMetadataSchemaModalFlag = (flag) => {
        this.setState({ modalFlag: flag });
    };
    render() {
        let metaDataFlag = false;
        const { selectedActivityData } = this.props
        const isProcessing = selectedActivityData &&
                             selectedActivityData.isLeafNode &&
                             selectedActivityData.isSmartActivity;
        const isPreProcessing = selectedActivityData &&
                             selectedActivityData.isLeafNode &&
                             !selectedActivityData.isSmartActivity;
        const isPostProcessing = selectedActivityData &&
                             selectedActivityData.isLeafNode &&
                             !selectedActivityData.isSmartActivity;
        // if(this.props.selectedActivityData.createdBy===this.props.user._id){
        //     metaDataFlag = true;
        // }
        // Below changes made for KLM-8942
        if (this.isWorkspaceOwner() || this.isDesigner()) {
            metaDataFlag = true;
        }
        const errorLabel = <div className="customErrorLabel" />;

        let activitiesForDependency = [];
        let initiativeData;
        if (this.props.activeTab === 'myactivities') {
            activitiesForDependency = selectedActivityData.initiativeId ? selectedActivityData.initiativeId.activities : [];
            initiativeData = selectedActivityData.initiativeId;
        } else {
            activitiesForDependency = this.props.selectedDataById.activities;
            initiativeData = this.props.selectedDataById;
        }
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let raci = selectedActivityData.raci;

        let raciLength = raci ?
            (raci.r ? raci.r.length : 0 +
                raci.c ? raci.c.length : 0 +
                    raci.i ? raci.i.length : 0) + 1 : 0

        let counts = {}

        if (selectedActivityData) {
            counts.notesLength = <Label>{selectedActivityData.notes && selectedActivityData.notes.length}</Label>
            counts.assignmentLength = <Label>{raciLength}</Label>
            counts.attachmentsLength = <Label>{selectedActivityData.attachments && selectedActivityData.attachments.length}</Label>
            counts.dependenciesLength = <Label>{selectedActivityData.dependencies && selectedActivityData.dependencies.length}</Label>
            counts.referencesLength = <Label>{selectedActivityData.references && selectedActivityData.references.length}</Label>
        }
        
        
        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    {initiativeData ?
                        <Accordion
                            // activeIndex={this.state.activeIndex}
                            // onActivate={(activeIndex) => this.setState({ activeIndex })}
                            expandTool={expandTool}
                            horizontal
                            className="practiceFlowResourcePane"
                            enableKeyboardNavigation={false}>
                            {[
                                selectedActivityData.isParentNode ?
                                    null : <div tabTitle="Status" key="Status">
                                        <div className="acc-header">Status
                                        {(selectedActivityData.onHoldComments &&
                                                selectedActivityData.onHoldComments.length > 0)
                                                || (selectedActivityData.issueLogComments &&
                                                    selectedActivityData.issueLogComments.length > 0) ?
                                                <span className="clr-blue f_10 pull-right cursor-pointer" onClick={this.viewIssueLogsClick} onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Activity Log")}>
                                                    Activity Logs
                                         </span> :
                                                <span className="clr-blue f_11 ff_n pull-right opacity-5" onMouseEnter={() => dispatch.app.setHelpContext("Status Card - Activity Log")}>
                                                    Activity Logs
                                         </span>
                                            }
                                        </div>
                                        <div>
                                            <Status name="Status Card - Overall" {...this.props} />
                                        </div>
                                    </div>,
                                this.props.activeTab === "myactivities" &&
                                <div tabTitle="Initiative Details" key="Details">
                                    <div className="acc-header">Initiative Details</div>
                                    <div>
                                        <InitiativeDetails {...this.props} />
                                    </div>
                                </div>,
                                <div tabProps={{ title: 'Activity Summary' }} key="Activity">
                                    <div className="acc-header">Activity Summary</div>
                                    <div>
                                        <Summary name="Activity Summary Card" {...this.props} />
                                    </div>
                                </div>,
                                <div tabTitle={<div>User Assignment {counts.assignmentLength} </div>} key="User">
                                    <div className="acc-header">User Assignment {counts.assignmentLength}
                                        <span className="pull-right">
                                            {/* {selectedActivityData && selectedActivityData.isParentNode &&
                                                <Button className="button-info float-right" content='Propagate RACI' icon='sort content ascending' onClick={this.propagateChangesToChildren} />
                                            } */}
                                        </span>
                                    </div>
                                    <AssignRole name="User Assignment Card" selectedDataById={initiativeData} {...this.props} />
                                </div>,
                                selectedActivityData.isParentNode ?
                                    null :
                                    <div tabTitle={<div>Depends On {counts.dependenciesLength} </div>} key="Depends">
                                        <div className="acc-header">Depends On {counts.dependenciesLength}</div>
                                        <Dependency {...this.props} activityOptions={activitiesForDependency} />
                                    </div>,
                                <div tabTitle={<div>Comments {counts.notesLength} </div>} key="Notes">
                                    <div className="acc-header">Comments {counts.notesLength}


                                        {(initiativeData.status === 1 || initiativeData.status === 2) &&
                                            <Icon name='plus' className="cursor-pointer" color='green' onClick={() => this.notesClick(true, "addNote")} />
                                            // <span className="pull-right">
                                            //     <Button className="button-submit" size="tiny" onClick={() => this.notesClick(true, "addNote")} >Add Notes</Button>
                                            // </span>
                                        }
                                    </div>
                                    <div>
                                        <Notes
                                            notes={selectedActivityData.notes}
                                            user={this.props.user}
                                            notesClick={this.notesClick}
                                            status={initiativeData.status}
                                            string='intiativeActivityProgressView'
                                            selectedData={selectedActivityData}
                                            role={this.props.selectedOrganisation.role}
                                        />
                                    </div>
                                </div>,
                                <div tabTitle={<div>References {counts.referencesLength} </div>} key="References">
                                    <div className="acc-header">References {counts.referencesLength} </div>
                                    <Reference
                                        name="References Card" selectedActivityData={this.props.selectedActivityData}
                                        {...this.props} />
                                </div>,
                                <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>}>
                                    <div className="acc-header">Attachments {counts.attachmentsLength}

                                        {/* {initiativeData.status === 2 || initiativeData.status === 3 ?
                                                null : 
                                                <Icon name='plus' className="cursor-pointer" color='green' onClick={this.handleUppyModalClick} />
                                        } */}

                                        {initiativeData.status === 2 || initiativeData.status === 3 ?
                                            null :
                                            <span className="pull-right" style={{ margin: "4px 0px" }}>
                                                <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Upload File' onClick={this.handleUppyModalClick} />
                                                <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Add Link' onClick={() => this.setState({ linkOpen: true })} />
                                            </span>}
                                    </div>
                                    <FileUploader
                                        data={selectedActivityData}
                                        action={this.addAttachment}
                                        openDashboard={this.state.openDashboard}
                                        handleUppyModalClick={this.handleUppyModalClick}
                                        entityName="initiativeActivity"
                                        initiativeStatus={initiativeData.status}
                                        selectedOrganization={this.props.selectedOrganisation}
                                        selectedInitiative={this.props.selectedDataById}
                                        to='initiativeActivity'
                                    />
                                </div>,
                                this.props.selectedActivityData && this.props.selectedActivityData.initiativeId && this.props.selectedActivityData.initiativeId.includeChecklist ?
                                    <div tabTitle="Checklist">
                                        <div className="acc-header">Checklist  
                                        {((this.props.selectedActivityData && this.props.selectedActivityData.originalId && this.props.selectedActivityData.originalId.metaDataSchema) && (this.props.selectedActivityData && this.props.selectedActivityData.runStatus === 0) )? 
                                        <span style={{color:"orange"}}>  (Please start the activity to enable the checklist.)</span>:""}</div>   
                                        {this.props.selectedActivityData && this.props.selectedActivityData.originalId && this.props.selectedActivityData.originalId.metaDataSchema ? (
                                            <div className="resourcePaneOverflow">
                                                <DynamicForm
                                                    fieldsData={this.props.selectedActivityData.originalId.metaDataSchema}
                                                    showAsterisk={true}
                                                    disabled={true}
                                                    showSubmit={false}
                                                    {...this.props}
                                                />
                                            </div>
                                        ) : (
                                            <span className="clr-orange">No metaData Schema to display</span>
                                        )}
                                    </div>
                                :""
                                ,
                                <div tabTitle="MetaData">
                                <div className="acc-header">
                                    MetaData 
                                    <span
                                        style={{ margin: "0 20px" }}
                                        className="clr-gray fs_italic"
                                    >
                                    {(metaDataFlag && this.props.selectedActivityData &&
                                        this.props.selectedActivityData.metaData) ? (
                                            <Button
                                            disabled={!metaDataFlag}
                                            content="Edit"
                                            className="button-submit float-right "
                                            type="button"
                                            onClick={() => this.setMetadataSchemaModalFlag(true)}
                                            />
                                        ) : null}
                                    </span>
                                </div>
                                {this.props.selectedActivityData &&
                                    this.props.selectedActivityData.metaData ? (
                                    <div className="resourcePaneOverflow">
                                        <pre>
                                        {JSON.stringify(
                                            this.props.selectedActivityData.metaData,
                                            null,
                                            2
                                        )}
                                        </pre>
                                    </div>
                                ) : <span className="clr-orange">No metaData to display</span>}
                            </div>,
                                isProcessing ? <div tabTitle={<div>Processing</div>}>
                                    <ProcessComponent {...this.props} processingType="Processing" /></div>:"",
                                isPreProcessing ? <div tabTitle={<div>Pre Processing</div>}>
                                    <ProcessComponent {...this.props} processingType="Pre Processing" /></div>:"",
                                isPostProcessing ? <div tabTitle={<div>Post Processing</div>}>
                                    <ProcessComponent {...this.props} processingType="Post Processing" /></div>:""   
                            ].filter(elem => !!elem)}
                        </Accordion> : null
                    }

                    <NotesModal notes={selectedActivityData.notes}
                        selectedData={selectedActivityData}
                        user={this.props.user}
                        open={this.state.open}
                        notesClick={this.notesClick}
                        currentNote={this.props.currentNote}
                        clickStatus={this.state.clickStatus}
                        string='intiativeActivityProgressView' />
                    <IssueLogModal openIssueLog={this.state.openIssueLog}
                        viewIssueLogsClick={this.viewIssueLogsClick}
                        selectedActivityData={selectedActivityData} />

                    <Modal
                        className="basicModal"
                        open={this.state.linkOpen}
                        size='mini'
                        onClose={this.close}
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Modal.Header>Add File</Modal.Header>
                        <Divider style={{ margin: "10px 0 0px" }} />
                        <Modal.Content scrolling>
                            <Form noValidate
                                ref={ref => this.form = ref}
                                id="AddLink"
                                onValid={(e) => this.setState({ validForm: true })}
                                onInvalid={(e) => this.setState({ validForm: false })}
                            >
                                <Form.Input
                                    required
                                    name="Add Link Name"
                                    id="Add Link Name"
                                    label="Add Link Name"
                                    value={this.state.name}
                                    placeholder="Add Link Name"
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: `Link Name is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                    autoFocus={true}
                                />

                                <Form.Input
                                    required
                                    name="Add Url"
                                    id="Add Url"
                                    label="Add Url"
                                    value={this.state.url}
                                    placeholder="Add Url"
                                    validations={{ matchRegexp: urlValidation }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Enter valid URL',
                                        isDefaultRequiredValue: `Url is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ url: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                />
                            </Form>
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}>
                            <Button disabled={!this.state.validForm} content='Add Link' className="button-submit float-right" type="button" onClick={this.addLink} />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>
                    </Modal>
                </div>
                <ShowInitiativeMetaData
                open={this.state.modalFlag}
                setMetadataSchemaModalFlag={this.setMetadataSchemaModalFlag}
                selectedInitiative={this.props.selectedActivityData}
                metaData={
                    this.props.selectedActivityData &&
                    this.props.selectedActivityData.metaData
                }
                view="sequence"
                />
            </div >
        )
    }
}


export default ActiveInitiative;

